<script>
import Label from './Label.vue'

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        type: String,
        required: false,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        last_updated: {
            type: Object,
            required: false
        },
        selectedItem: {
            type: Object,
            required: true
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Label
    },
    data() {
        return {
            value: this.item_value,
            display_none_check: this.selectedItem && this.item.displayOn && this.selectedItem[this.item.displayOn] ? this.selectedItem[this.item.displayOn].find(x => JSON.stringify(x) == this.item.displayOnValue) ? true : false : false,
            disable_check: this.selectedItem && this.item.disableOn && this.selectedItem[this.item.disableOn]  ? this.selectedItem[this.item.disableOn].find(x => JSON.stringify(x) == this.item.disableOnValue) ? true : false : false
        };
    },
    watch: {
        last_updated: {
            handler(val) {
                if(val && this.item.displayOn && val.key == this.item.displayOn) {   
                    let check = val.value.find(x => JSON.stringify(x) == this.item.displayOnValue)   
                    this.display_none_check = check ? true : false;
                }                 
                if(val && this.item.disableOn && val.key == this.item.disableOn) {   
                    let d_check = val.value.find(x => JSON.stringify(x) == this.item.disableOnValue) 
                    this.disable_check = d_check ? true : false;
                }
            },
            deep: true
        },
        item_value: {
            handler(val) {
                this.value = val;
            },
            deep: true
        },
        selectedItem: {
            handler(val) {
                this.display_none_check = val && this.item.displayOn && val[this.item.displayOn] ? val[this.item.displayOn].find(x => JSON.stringify(x) == this.item.displayOnValue) ? true : false : false,
                this.disable_check = val && this.item.disableOn && val[this.item.disableOn]  ? val[this.item.disableOn].find(x => JSON.stringify(x) == this.item.disableOnValue) ? true : false : false
            },
            deep: true
        },
        value(val) {
            this.updateValue(this.item_key, val);
        }
    }
};
</script>
<template>
    <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check }">
        <Label :item="item"/>
        <input
            v-model="value"
            type="time"
            class="form-control"
            :class="{ 'is-invalid': submitted && validation.$error, 'bg-soft-secondary': item.disableOn && disable_check }"
            :placeholder="item.placeholder"
            :disabled="item.disableOn && disable_check"
        />
        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>